import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './components/Home';
import Sobre from './components/Sobre';
import Servicos from './components/Servicos';
import Clientes from './components/Clientes';
import Contato from './components/Contato';
import NossosNumeros from './components/NossosNumeros';
import Neuroscan from './pages/NeuroscanPage';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import CookieConsent from "react-cookie-consent";
import CanalDenuncias from './pages/CanalDenuncias';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route 
            path="/" 
            element={
              <>
                <Home />
                <Sobre />
                <Servicos />
                <NossosNumeros />
                <Clientes />
                <Contato />
              </>
            } 
          />
          <Route path="/neuroscan" element={<Neuroscan />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/canal-de-denuncias" element={<CanalDenuncias />} />
        </Routes>
      </main>

      {/* 👇 Banner de cookies aqui */}
      <CookieConsent
        location="bottom"
        buttonText="Aceitar"
        declineButtonText="Recusar"
        enableDeclineButton
        cookieName="amaratechCookieConsent"
        style={{
          background: "#000",
          color: "#fff",
          fontSize: "14px",
          padding: "18px 0px",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.3)"
        }}
        buttonStyle={{
          background: "#009cfe",
          color: "#fff",
          borderRadius: "8px",
          padding: "8px 18px",
          fontWeight: "bold",
        }}
        declineButtonStyle={{
          background: "transparent",
          color: "#49e9fe",
          border: "1px solid #49e9fe",
          borderRadius: "8px",
          padding: "8px 18px",
          marginLeft: "10px",
        }}
        expires={150}
      >
        <span>
          Usamos cookies para melhorar sua experiência, personalizar conteúdo e analisar nosso tráfego. 
          Ao clicar em <strong>Aceitar</strong>, você concorda com o uso de cookies conforme nossa{" "}
          <a 
            href="/politica-de-privacidade" target="_blank"
            style={{ color: "#49e9fe", textDecoration: "underline" }}
          >
            Política de Privacidade
          </a>.
        </span>
      </CookieConsent>
    </Router>
  );
}

export default App;
